import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import styles from "./header.module.scss";
import { FC, useState, useEffect } from "react";
import Footer from "../footer/footer";
import useRWD from "../../hooks/useRWD";
import { DeviceType } from "../../hooks/useRWD";
import { log } from "console";

const HeaderLayout: FC = () => {
  const device = useRWD();
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const backWebUrl = process.env.REACT_APP_DA_CHAUNG_BACK_WEB_URL;

  const menuItem: any[] = [
    { moduleName: "關於我們", url: "about-us" },
    { moduleName: "我想買/賣電", url: "home#constomSlider" },
    { moduleName: "Q&A", url: "faq" },
    { moduleName: "聯絡大創", url: "home#contactUs" },
  ];

  const openMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const goToHome = () => {
    navigate("/home");
  };

  const isActive = (url: string) => {
    if (url === "home") {
      return location.pathname === "/" || location.pathname === "/home";
    }
    return location.pathname === `/${url}`;
  };

  const getLinkClassName = (url: string) => {
    return isActive(url) ? "" : `${styles.active}`;
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [location.pathname]);

  return (
    <div className={styles["header-box"]}>
      {/* Navbar */}
      {device === DeviceType.PC && (
        <div className="header">
          <div className="container">
            <div className="row">
              <nav className={`${styles["header-nav"]}`}>
                <div onClick={goToHome} className="logo-box">
                  <img alt="logo" src="/assets/images/logo/white-logo.png" />
                  {/* <div className="logo-title">大創電力</div> */}
                </div>
                <ul className="nav_links">
                  {menuItem.map((item, index) => (
                    <li key={index}>
                      <NavLink
                        to={item.url}
                        className={getLinkClassName(item.url)}
                      >
                        <div className="item">{item.moduleName}</div>
                      </NavLink>
                    </li>
                  ))}
                  <a href="https://www.facebook.com/p/大創綠能股份有限公司-100075986388452/" target="_blank" rel="noopener noreferrer">
                    <img
                      src="/assets/images/header/facebook.svg"
                      alt="facebook"
                      className="fb_icon"
                    />
                  </a>
                  <NavLink
                    to={backWebUrl!}
                    className="loginBtn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="login_icon"
                      src="/assets/images/header/login-icon.png"
                      alt="login"
                    />
                    平台登入
                  </NavLink>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      )}
      {device !== DeviceType.PC && (
        <div className="header">
          <div className="container-fluid">
            <nav className={`${styles["header-nav"]} container`}>
              <div className="logo-box">
                <NavLink to="/home">
                  <img alt="logo" src="/assets/images/logo/white-logo.png" />
                </NavLink>
                {/* <div className="logo-title">大創電力</div> */}
              </div>
              {isMenuOpen === false ? (
                <div className="btn_box">
                  <img
                    className="hamburger"
                    src="/assets/images/header/ham.svg"
                    alt="nav-hamburger"
                    onClick={openMenu}
                  />
                </div>
              ) : (
                <div className="btn_box">
                  <img
                    className="cancel"
                    src="/assets/images/modal/close.svg"
                    alt="cancel"
                    onClick={openMenu}
                  />
                </div>
              )}
              <div className={`mobile_nav_links ${isMenuOpen ? "open" : ""}`}>
                {menuItem.map((item, index) => (
                  <div className="d-flex justify-content-between" key={index}>
                    <NavLink
                      onClick={openMenu}
                      to={item.url}
                      className={getLinkClassName(item.url)}
                    >
                      <div className="item">{item.moduleName}</div>
                    </NavLink>
                    <NavLink
                      onClick={openMenu}
                      to={item.url}
                      className={getLinkClassName(item.url)}
                    >
                      <img alt="icon" src="/assets/images/header/icon.png" />
                    </NavLink>
                  </div>
                ))}
                <div>
                  <a className="d-flex justify-content-between" href="https://www.facebook.com/p/大創綠能股份有限公司-100075986388452/" target="_blank" rel="noopener noreferrer">
                    <div style={{ color: "#fff" }} className="Fb">
                      FACEBOOK
                    </div>
                    <img alt="icon" src="/assets/images/header/icon.png" />
                  </a>
                </div>

                <NavLink
                  to={backWebUrl!}
                  className="loginBtn">
                  <img
                    className="login_icon"
                    src="/assets/images/header/login-icon.png"
                    alt="login"
                  />
                  綠電平台登入
                </NavLink>


              </div>
            </nav>
          </div>
        </div>
      )}
      <div
        className={`content-box`}
        style={{
          marginTop: "77px",
        }}
      >
        <>
          {/* 子層替換 */}
          <div className="layout-container-box">
            <Outlet />
          </div>
          <Footer />
        </>
      </div>
    </div>
  );
};

export default HeaderLayout;
